import React, { useState } from "react";
import BarcodeScannerView from "./BarcodeScannerView";
import ProductCaptureView from "./ProductCaptureView";
import { ScanMode } from "./ScannerSharedComponents";

// Switches between Barcode and Product classification views based on active mode
const ScannerPage: React.FC = () => {
  const [activeMode, setActiveMode] = useState<ScanMode>(ScanMode.BARCODE);

  if (activeMode === ScanMode.PRODUCT) {
    return (
      <ProductCaptureView
        activeMode={activeMode}
        onModeChange={setActiveMode}
      />
    );
  }

  return (
    <BarcodeScannerView activeMode={activeMode} onModeChange={setActiveMode} />
  );
};

export default ScannerPage;
